import React, {Component} from 'react';
import {Input} from 'reactstrap';

class ComboInput extends Component {
	render() {
		if (this.props.indVar === '1' || this.props.indVar === '0') {
			let boolCheck = this.props.castToBool(this.props.indVar);
			if (
				this.props.inputType === 'select' &&
				this.props.valueArray &&
				this.props.valueArray.length > 0
			) {
				let options = [];
				this.props.valueArray.forEach((option, i) => {
					if (i === 0) {
						options.push(
							<option key="0" value="0">
								No Selection
							</option>
						);
					}

					options.push(
						<option key={i + 1} value={option.id}>
							{option.value}
						</option>
					);
				});

				return (
					<Input
						id={`${this.props.parentID}-${this.props.label}`}
						className="rounded-0 content-input"
						onChange={(e) => {
							e.preventDefault();
							this.props.triggerFormValueChange(e);
						}}
						type={this.props.inputType}
						value={this.props.value}
						disabled={!boolCheck}
					>
						{options}
					</Input>
				);
			};
			let textInput = (<Input
				id={`${this.props.parentID}-${this.props.label}`}
				className={this.props.labelStackedOnTop ? 'rounded-0 content-input comboStacked' : 'rounded-0 content-input'}
				onChange={(e) => {
					e.preventDefault();
					this.props.triggerFormValueChange(e);
				}}
				type={this.props.inputType}
				value={this.props.value}
				disabled={!boolCheck}
			/>)
			if (this.props.maxLength) {
				textInput = (<Input
					id={`${this.props.parentID}-${this.props.label}`}
					className={this.props.labelStackedOnTop ? 'rounded-0 content-input comboStacked' : 'rounded-0 content-input'}
					onChange={(e) => {
						e.preventDefault();
						this.props.triggerFormValueChange(e);
					}}
					type={this.props.inputType}
					value={this.props.value}
					disabled={!boolCheck}
					maxLength={255}
				/>)
			}
			return (
				<React.Fragment>
					{textInput}
				</React.Fragment>
			);
		}

		return (
			<p>
				{this.props.humanLabel} cannot be rendered because{' '}
				{this.props.indVarLabel} is not a boolean
			</p>
		);
	}
}

export default ComboInput;



// WEBPACK FOOTER //
// ./src/components/ComboInput.js